import React, { useState } from 'react';
import MenuHeading from '../MenuHeading';

const TrackingContent = () => {
  const [trackingId, setTrackingId] = useState('');
  const [articleStatus, setArticleStatus] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate API call to fetch article status
    // In a real application, this would be an API call
    setArticleStatus({
      id: trackingId,
      title: "Sample Article Title",
      status: "Under Review",
      lastUpdated: "2024-03-20",
      currentStage: "Peer Review",
      nextStage: "Editorial Review",
      estimatedCompletion: "2024-04-20"
    });
  };

  return (
    <div className="animate-fadein">
      <div className="mb-10 max-w-5xl mx-auto">
        <MenuHeading title="Track Your Article" />
      </div>
      
      <div className="max-w-3xl mx-auto bg-white p-6 rounded shadow">
        <form onSubmit={handleSubmit} className="mb-8">
          <div className="flex gap-4">
            <input
              type="text"
              value={trackingId}
              onChange={(e) => setTrackingId(e.target.value)}
              placeholder="Enter your tracking ID"
              className="flex-1 px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
              required
            />
            <button
              type="submit"
              className="bg-accent text-white py-2 px-6 rounded-md hover:bg-heading transition-colors duration-300"
            >
              Track
            </button>
          </div>
        </form>

        {articleStatus && (
          <div className="bg-gray-50 rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4">Article Status</h2>
            
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-medium">Article Details</h3>
                <p className="text-gray-600">Title: {articleStatus.title}</p>
                <p className="text-gray-600">Tracking ID: {articleStatus.id}</p>
              </div>

              <div>
                <h3 className="text-lg font-medium">Current Status</h3>
                <div className="mt-2">
                  <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 rounded-full">
                    {articleStatus.status}
                  </span>
                </div>
              </div>

              <div>
                <h3 className="text-lg font-medium">Progress</h3>
                <div className="mt-2 space-y-2">
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                    <span className="text-gray-600">Submission</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                    <span className="text-gray-600">Initial Review</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                    <span className="text-gray-600">Peer Review (Current)</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-gray-300 rounded-full mr-2"></div>
                    <span className="text-gray-600">Editorial Review</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-gray-300 rounded-full mr-2"></div>
                    <span className="text-gray-600">Final Decision</span>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-lg font-medium">Timeline</h3>
                <p className="text-gray-600">Last Updated: {articleStatus.lastUpdated}</p>
                <p className="text-gray-600">Estimated Completion: {articleStatus.estimatedCompletion}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TrackingContent; 